(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.hero--fixed').forEach(hero => {
    const container = hero.querySelector('.hero__container');
    const media = hero.querySelector('.hero__media-wrapper');
    if (!container || !media) return;

    const mql = window.matchMedia('(min-width: 750px)');
    const range = 300;
    let ticking = false;

    function update() {
      if (!mql.matches) {
        media.style.transform = '';
        return;
      }
      const rect = container.getBoundingClientRect();
      const viewH = window.innerHeight;
      const progress = Math.min(Math.max((viewH - rect.top) / (viewH + rect.height), 0), 1);
      media.style.transform = 'translateY(' + (progress * range - range * 0.5) + 'px)';
      ticking = false;
    }

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          window.addEventListener('scroll', onScroll, { passive: true });
          update();
        } else {
          window.removeEventListener('scroll', onScroll);
        }
      });
    });

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }

    observer.observe(container);
  });

  window.initHeroExpand = function(hero) {
    if (hero._expandAbort) hero._expandAbort.abort();
    const ac = new AbortController();
    hero._expandAbort = ac;

    let ticking = false;
    const threshold = parseInt(hero.dataset.expandThreshold) || 300;
    const triggerPercent = parseFloat(hero.dataset.expandTrigger) || 0;

    function getDocTop() {
      return hero.getBoundingClientRect().top + window.scrollY;
    }

    let docTop = getDocTop();

    function update() {
      const start = Math.max(0, docTop - window.innerHeight * (1 - triggerPercent / 100));
      const progress = Math.min(Math.max((window.scrollY - start) / threshold, 0), 1);
      hero.style.setProperty('--expand-progress', progress);
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true, signal: ac.signal });
    window.addEventListener('resize', () => { docTop = getDocTop(); }, { signal: ac.signal });
    update();
  };

  document.querySelectorAll('.hero[data-animate-expand]').forEach(window.initHeroExpand);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-active"] && !Shopify.designMode) return;
  try {
    
  // View transitions
  document.querySelectorAll('.index-active__item[data-active-id]').forEach((item) => {
    item.addEventListener('click', (e) => {
      if (e.target.closest('a, button, input, textarea, select')) return;
      item.setAttribute('data-view-transition-triggered', 'true');
    });
    const link = item.querySelector('.group-block__link');
    if (link) {
      link.addEventListener('click', () => {
        item.setAttribute('data-view-transition-triggered', 'true');
      });
    }
  });

  // Filter toggle
  document.querySelectorAll('[data-filter-toggle]').forEach((toggle) => {
    const wrapper = toggle.closest('.index-active__dropdown-wrapper');
    const dropdown = wrapper.querySelector('[data-filter-groups]');

    toggle.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = !dropdown.hidden;
      dropdown.hidden = isOpen;
      toggle.classList.toggle('index-active__filter-toggle--active', !isOpen);
    });

    document.addEventListener('click', (e) => {
      if (!wrapper.contains(e.target) && !dropdown.hidden) {
        dropdown.hidden = true;
        toggle.classList.remove('index-active__filter-toggle--active');
      }
    });
  });

  // Filters & Search
  document.querySelectorAll('[data-active-filters]').forEach((filtersContainer) => {
    const section = filtersContainer.closest('.index-active-section');
    if (!section) return;

    const items = section.querySelectorAll('.index-active__item');
    const searchInput = filtersContainer.querySelector('[data-active-search]');
    let activePreoccupation = 'all';
    let activeType = 'all';
    let searchQuery = '';

    function filterItems() {
      items.forEach((item) => {
        const preocc = item.getAttribute('data-preoccupations') || '';
        const type = item.getAttribute('data-type-ingredient') || '';
        const name = item.getAttribute('data-name') || '';

        const matchPreocc = activePreoccupation === 'all' || preocc.split(',').includes(activePreoccupation);
        const matchType = activeType === 'all' || type === activeType;
        const matchSearch = !searchQuery || name.includes(searchQuery);

        item.style.display = matchPreocc && matchType && matchSearch ? '' : 'none';
      });
    }

    if (searchInput) {
      searchInput.addEventListener('input', () => {
        searchQuery = searchInput.value.toLowerCase().trim();
        filterItems();
      });
    }

    filtersContainer.querySelectorAll('.index-active__pill').forEach((pill) => {
      pill.addEventListener('click', () => {
        const filterType = pill.getAttribute('data-filter');
        const value = pill.getAttribute('data-value');

        // Update active state within the same group
        pill
          .closest('.index-active__filter-pills')
          .querySelectorAll('.index-active__pill')
          .forEach((p) => p.classList.remove('index-active__pill--active'));
        pill.classList.add('index-active__pill--active');

        if (filterType === 'preoccupation') {
          activePreoccupation = value;
        } else if (filterType === 'type') {
          activeType = value;
        }

        filterItems();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-presse"] && !Shopify.designMode) return;
  try {
    
  // View transitions
  document.querySelectorAll('.index-presse__item[data-presse-id]').forEach((item) => {
    item.addEventListener('click', (e) => {
      if (e.target.closest('a, button, input, textarea, select')) return;
      item.setAttribute('data-view-transition-triggered', 'true');
    });
    const link = item.querySelector('.group-block__link');
    if (link) {
      link.addEventListener('click', () => {
        item.setAttribute('data-view-transition-triggered', 'true');
      });
    }
  });

  // Filter toggle
  document.querySelectorAll('[data-filter-toggle]').forEach((toggle) => {
    const wrapper = toggle.closest('.index-presse__dropdown-wrapper');
    if (!wrapper) return;
    const dropdown = wrapper.querySelector('[data-filter-groups]');

    toggle.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = !dropdown.hidden;
      dropdown.hidden = isOpen;
      toggle.classList.toggle('index-presse__filter-toggle--active', !isOpen);
    });

    document.addEventListener('click', (e) => {
      if (!wrapper.contains(e.target) && !dropdown.hidden) {
        dropdown.hidden = true;
        toggle.classList.remove('index-presse__filter-toggle--active');
      }
    });
  });

  // Filters & Search
  document.querySelectorAll('[data-presse-filters]').forEach((filtersContainer) => {
    const section = filtersContainer.closest('.index-presse-section');
    if (!section) return;

    const items = section.querySelectorAll('.index-presse__item');
    const searchInput = filtersContainer.querySelector('[data-presse-search]');
    let activeTitle = 'all';
    let activeType = 'all';
    let activeYear = 'all';
    let searchQuery = '';

    function filterItems() {
      items.forEach((item) => {
        const year = item.getAttribute('data-year') || '';
        const types = (item.getAttribute('data-types') || '').split(',');
        const search = item.getAttribute('data-search') || '';

        const matchType = activeType === 'all' || types.includes(activeType);
        const matchYear = activeYear === 'all' || year === activeYear;
        const matchSearch = !searchQuery || search.includes(searchQuery);

        item.style.display = matchType && matchYear && matchSearch ? '' : 'none';
      });
    }

    if (searchInput) {
      searchInput.addEventListener('input', () => {
        searchQuery = searchInput.value.toLowerCase().trim();
        filterItems();
      });
    }

    filtersContainer.querySelectorAll('.index-presse__pill').forEach((pill) => {
      pill.addEventListener('click', () => {
        const filterType = pill.getAttribute('data-filter');
        const value = pill.getAttribute('data-value');

        pill
          .closest('.index-presse__filter-pills')
          .querySelectorAll('.index-presse__pill')
          .forEach((p) => p.classList.remove('index-presse__pill--active'));
        pill.classList.add('index-presse__pill--active');

        if (filterType === 'type') activeType = value;
        else if (filterType === 'year') activeYear = value;

        filterItems();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-public-figure"] && !Shopify.designMode) return;
  try {
    
  // View transitions
  document.querySelectorAll('.index-public-figure__item[data-public-figure-id]').forEach((item) => {
    item.addEventListener('click', (e) => {
      if (e.target.closest('a, button, input, textarea, select')) return;
      item.setAttribute('data-view-transition-triggered', 'true');
    });
    const link = item.querySelector('.group-block__link');
    if (link) {
      link.addEventListener('click', () => {
        item.setAttribute('data-view-transition-triggered', 'true');
      });
    }
  });

  // Search
  document.querySelectorAll('[data-public-figure-filters]').forEach((filtersContainer) => {
    const section = filtersContainer.closest('.index-public-figure-section');
    if (!section) return;

    const items = section.querySelectorAll('.index-public-figure__item');
    const searchInput = filtersContainer.querySelector('[data-public-figure-search]');
    let searchQuery = '';

    function filterItems() {
      items.forEach((item) => {
        const name = item.getAttribute('data-name') || '';
        const matchSearch = !searchQuery || name.includes(searchQuery);
        item.style.display = matchSearch ? '' : 'none';
      });
    }

    if (searchInput) {
      searchInput.addEventListener('input', () => {
        searchQuery = searchInput.value.toLowerCase().trim();
        filterItems();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-technology"] && !Shopify.designMode) return;
  try {
    
  // View transitions
  document.querySelectorAll('.index-technology__item[data-technology-id]').forEach((item) => {
    item.addEventListener('click', (e) => {
      if (e.target.closest('a, button, input, textarea, select')) return;
      item.setAttribute('data-view-transition-triggered', 'true');
    });
    const link = item.querySelector('.group-block__link');
    if (link) {
      link.addEventListener('click', () => {
        item.setAttribute('data-view-transition-triggered', 'true');
      });
    }
  });

  // Search
  document.querySelectorAll('[data-technology-filters]').forEach((filtersContainer) => {
    const section = filtersContainer.closest('.index-technology-section');
    if (!section) return;

    const items = section.querySelectorAll('.index-technology__item');
    const searchInput = filtersContainer.querySelector('[data-technology-search]');
    let searchQuery = '';

    function filterItems() {
      items.forEach((item) => {
        const name = item.getAttribute('data-name') || '';
        const matchSearch = !searchQuery || name.includes(searchQuery);
        item.style.display = matchSearch ? '' : 'none';
      });
    }

    if (searchInput) {
      searchInput.addEventListener('input', () => {
        searchQuery = searchInput.value.toLowerCase().trim();
        filterItems();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-user-guides"] && !Shopify.designMode) return;
  try {
    
  // View transitions
  document.querySelectorAll('.index-user-guides__item[data-guide-id]').forEach((item) => {
    item.addEventListener('click', (e) => {
      if (e.target.closest('a, button, input, textarea, select')) return;
      item.setAttribute('data-view-transition-triggered', 'true');
    });
    const link = item.querySelector('.index-user-guides__link');
    if (link) {
      link.addEventListener('click', () => {
        item.setAttribute('data-view-transition-triggered', 'true');
      });
    }
  });

  // Search
  document.querySelectorAll('[data-guide-filters]').forEach((filtersContainer) => {
    const section = filtersContainer.closest('.index-user-guides-section');
    if (!section) return;

    const items = section.querySelectorAll('.index-user-guides__item');
    const searchInput = filtersContainer.querySelector('[data-guide-search]');
    let searchQuery = '';

    function filterItems() {
      items.forEach((item) => {
        const name = item.getAttribute('data-name') || '';
        const matchSearch = !searchQuery || name.includes(searchQuery);
        item.style.display = matchSearch ? '' : 'none';
      });
    }

    if (searchInput) {
      searchInput.addEventListener('input', () => {
        searchQuery = searchInput.value.toLowerCase().trim();
        filterItems();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-with-content"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.media-with-content--fixed').forEach(section => {
    const block = section.querySelector('.media-block');
    const media = block?.querySelector('.media-block__media');
    if (!block || !media) return;

    const range = 300;
    let ticking = false;

    function update() {
      const rect = block.getBoundingClientRect();
      const viewH = window.innerHeight;
      const progress = Math.min(Math.max((viewH - rect.top) / (viewH + rect.height), 0), 1);
      media.style.transform = 'translateY(' + (progress * range - range * 0.5) + 'px)';
      ticking = false;
    }

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          window.addEventListener('scroll', onScroll, { passive: true });
          update();
        } else {
          window.removeEventListener('scroll', onScroll);
        }
      });
    });

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }

    observer.observe(block);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nooance-peptide-cuivre"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nooance-peptide-motion')) {
    customElements.define('nooance-peptide-motion', class extends HTMLElement {
      connectedCallback() {
        if (this.motionController) return;
        this.motionController = new AbortController();
        const { signal } = this.motionController;
        // Use the same counter as Number columns. The entrance animation sets its start time.
        this.counter = import('@theme/count-up').catch(() => null);
        this.addEventListener('animationstart', (event) => {
          if (event.animationName !== 'blockFadeUp') return;
          this.countNumbers(event.target, signal);
        }, { signal });

        // A section may be upgraded after its first reveal (cached assets / theme editor).
        this.querySelectorAll('.is-visible .animate-child').forEach((element) => {
          const animation = element.getAnimations().find((item) => item.animationName === 'blockFadeUp');
          if (animation && animation.effect.getComputedTiming().progress !== null) {
            this.countNumbers(element, signal);
          }
        });
      }

      countNumbers(element, signal) {
        element.querySelectorAll('[data-count-up-value]').forEach((target) => {
          if (target.hasAttribute('data-count-up-done')) return;
          target.setAttribute('data-count-up-done', '');
          this.counter.then((counter) => {
            if (!signal.aborted && target.isConnected) counter?.animateCountUp(target, 1600, { signal });
          });
        });
      }

      disconnectedCallback() {
        this.motionController?.abort();
        this.motionController = null;
      }
    });
  }

  if (!customElements.get('nooance-peptide-media')) {
    customElements.define('nooance-peptide-media', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.video = this.querySelector('[data-peptide-video]');
        this.button = this.querySelector('[data-peptide-playback]');
        if (!this.video || !this.button) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.userPaused = false;
        this.failed = false;
        this.playbackEpoch = 0;
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.motionChanged = () => this.syncPlayback();
        this.motion.addEventListener('change', this.motionChanged);
        this.button.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.syncPlayback();
        }, options);
        this.video.addEventListener('playing', () => {
          if (this.motion.matches || !this.visible || this.userPaused) {
            this.video.pause();
            return;
          }
          this.video.hidden = false;
          this.button.hidden = false;
          this.updateButton(false);
        }, options);
        this.video.addEventListener('error', () => {
          this.failed = true;
          this.video.hidden = true;
          this.button.hidden = true;
        }, options);
        this.observer = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          this.syncPlayback();
        }, { threshold: 0 });
        this.observer.observe(this);
      }

      updateButton(paused) {
        this.button.setAttribute('aria-label', paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
        this.button.querySelector('[data-peptide-pause]').hidden = paused;
        this.button.querySelector('[data-peptide-play]').hidden = !paused;
      }

      syncPlayback() {
        if (!this.isConnected || this.failed) return;
        const playbackEpoch = ++this.playbackEpoch;
        if (this.motion.matches) {
          this.video.pause();
          this.video.hidden = true;
          this.button.hidden = true;
          return;
        }
        if (!this.visible || this.userPaused) {
          this.video.pause();
          this.updateButton(true);
          return;
        }
        if (!this.video.getAttribute('src')) {
          this.video.src = this.video.dataset.src;
          this.video.load();
        }
        this.video.play().catch(() => {
          if (playbackEpoch !== this.playbackEpoch || !this.isConnected || this.motion.matches || !this.visible || this.failed) return;
          this.userPaused = true;
          this.video.hidden = true;
          this.button.hidden = false;
          this.updateButton(true);
        });
      }

      disconnectedCallback() {
        this.playbackEpoch += 1;
        this.video?.pause();
        this.observer?.disconnect();
        this.motion?.removeEventListener('change', this.motionChanged);
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onglets-medias"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MQ = window.matchMedia('(max-width: 749px)');

    function initSection(root) {
      if (root.__omediasInit) return;
      root.__omediasInit = true;
      root.classList.add('omedias--js');

      var allPanels = Array.prototype.slice.call(root.querySelectorAll('[data-om-panel]'));
      if (!allPanels.length) return;

      // Un onglet sans titre n'a pas de bouton d'ouverture : il reste déplié.
      var panels = [];
      allPanels.forEach(function (panel) {
        if (panel.querySelector('[data-om-toggle]')) {
          panels.push(panel);
        } else {
          panel.classList.add('omedias-panel--static');
        }
      });
      if (!panels.length) return;

      function toggleVideos(panel, active) {
        panel.querySelectorAll('video').forEach(function (video) {
          if (active) {
            if (video.autoplay || video.hasAttribute('autoplay')) {
              var p = video.play();
              if (p && p.catch) p.catch(function () {});
            }
          } else {
            video.pause();
          }
        });
      }

      // État de départ (et éditeur) : n'ouvrir que cet onglet.
      function openOnly(target) {
        panels.forEach(function (panel) {
          var active = panel === target;
          panel.classList.toggle('is-active', active);
          var toggle = panel.querySelector('[data-om-toggle]');
          if (toggle && toggle.hasAttribute('role')) {
            toggle.setAttribute('aria-expanded', active ? 'true' : 'false');
          }
          if (MQ.matches) toggleVideos(panel, active);
        });
      }

      // Sur mobile, le titre devient un bouton d'accordéon accessible ; sur
      // desktop, on retire ces attributs (tout est visible, rien à ouvrir).
      function applyMode() {
        panels.forEach(function (panel) {
          var toggle = panel.querySelector('[data-om-toggle]');
          if (!toggle) return;
          if (MQ.matches) {
            toggle.setAttribute('role', 'button');
            toggle.setAttribute('tabindex', '0');
            toggle.setAttribute('aria-expanded', panel.classList.contains('is-active') ? 'true' : 'false');
          } else {
            toggle.removeAttribute('role');
            toggle.removeAttribute('tabindex');
            toggle.removeAttribute('aria-expanded');
            // Les vidéos autoplay mises en pause sur mobile doivent repartir.
            toggleVideos(panel, true);
          }
        });
      }

      // Chaque onglet s'ouvre et se referme indépendamment : taper un titre ne
      // touche qu'à ce qui est SOUS lui, donc rien ne bouge à l'écran et la
      // page n'a jamais besoin d'être recalée.
      function activate(panel) {
        var open = !panel.classList.contains('is-active');
        panel.classList.toggle('is-active', open);
        var toggle = panel.querySelector('[data-om-toggle]');
        if (toggle && toggle.hasAttribute('role')) {
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
        if (MQ.matches) toggleVideos(panel, open);
      }

      panels.forEach(function (panel) {
        var toggle = panel.querySelector('[data-om-toggle]');
        if (!toggle) return;
        toggle.addEventListener('click', function () {
          if (MQ.matches) activate(panel);
        });
        toggle.addEventListener('keydown', function (e) {
          if (!MQ.matches) return;
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            activate(panel);
          }
        });
      });

      openOnly(panels[0]);
      applyMode();

      if (MQ.addEventListener) {
        MQ.addEventListener('change', applyMode);
      } else if (MQ.addListener) {
        MQ.addListener(applyMode);
      }
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-onglets-medias]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    // Dans l'éditeur : sélectionner un block (ex. la vidéo d'un onglet replié
    // sur mobile) ouvre l'onglet correspondant pour le rendre visible.
    document.addEventListener('shopify:block:select', function (event) {
      var panel = event.target && event.target.closest && event.target.closest('[data-om-panel]');
      if (!panel) return;
      var root = panel.closest('[data-onglets-medias]');
      if (!root || !root.__omediasInit) return;
      panel.classList.add('is-active');
      Array.prototype.forEach.call(root.querySelectorAll('[data-om-panel]'), function (other) {
        if (other !== panel) other.classList.remove('is-active');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-clipping"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-press-clipping]').forEach((el) => {
    if (el.dataset.pcInit === '1') return;
    el.dataset.pcInit = '1';

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
    );

    observer.observe(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["refer"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.media-with-content--fixed').forEach((section) => {
    const block = section.querySelector('.media-block');
    const media = block?.querySelector('.media-block__media');
    if (!block || !media) return;

    const range = 300;
    let ticking = false;

    function update() {
      const rect = block.getBoundingClientRect();
      const viewH = window.innerHeight;
      const progress = Math.min(Math.max((viewH - rect.top) / (viewH + rect.height), 0), 1);
      media.style.transform = 'translateY(' + (progress * range - range * 0.5) + 'px)';
      ticking = false;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          window.addEventListener('scroll', onScroll, { passive: true });
          update();
        } else {
          window.removeEventListener('scroll', onScroll);
        }
      });
    });

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }

    observer.observe(block);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  // Marque chaque étape « vue » (.is-seen) quand 30% de sa surface entre dans
  // le viewport — qui clippe aussi horizontalement : sur mobile, les étapes
  // hors-champ du carrousel ne sont marquées qu'au scroll horizontal (au
  // scroll vertical en frise verticale, .timeline--vertical-mobile). Sur
  // desktop tout est marqué à l'arrivée, sans effet (le CSS n'utilise
  // .is-seen que sous 750px).
  (function () {
    function init(scope) {
      (scope || document).querySelectorAll('.timeline__track').forEach(function (track) {
        if (track._tlStepsInit) return;
        track._tlStepsInit = true;
        var steps = track.querySelectorAll('.timeline__step');
        if (!('IntersectionObserver' in window)) {
          steps.forEach(function (s) { s.classList.add('is-seen'); });
          return;
        }
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-seen');
                observer.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.3 }
        );
        steps.forEach(function (s) { observer.observe(s); });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
